
import { z } from "zod";

export const passwordSchema = z
  .string()
  .min(8, { message: "Password must be at least 8 characters" })
  .regex(/[A-Z]/, { message: "Password must contain at least 1 uppercase letter" })
  .regex(/[a-z]/, { message: "Password must contain at least 1 lowercase letter" })
  .regex(/[0-9]/, { message: "Password must contain at least 1 number" })
  .regex(/[^A-Za-z0-9]/, { message: "Password must contain at least 1 special character" });

export const registerFormSchema = z
  .object({
    email: z.string().email({ message: "Please enter a valid email address" }),
    password: passwordSchema,
  });

export type RegisterFormValues = z.infer<typeof registerFormSchema>;
